import _ from 'lodash';
import moment from 'moment';

// key : max diameter, value : segment name
const wheels_segments = {
  14: '13_14inches',
  18: '15_18inches',
  default: '18_20inches',
};

const power_segments = {
  74: '0_74kw',
  110: '75_110kw',
  180: '111_180kw',
  default: '181kw',
};

// in years
const age_segments = {
  5: 'less_than_5',
  default: 'more_than_5',
};

function applySegment(value, segments) {
  if (value === null) return segments.default;
  let segment = null;
  segment = Object.keys(segments).map((maxValue) => {
    if (maxValue === 'default' || value <= maxValue) {
      segment = segments[maxValue];
      return segment;
    }
    return null;
  });
  return segment.filter((s) => s !== null)[0];
}

// return the segment - set async because will be through api in the future
export default async function getSegment(report) {
  const { display } = report;
  // wheels diameter - parsing the file wheels_front_infos.rim_diameter: "205/55 R16"
  const wheelsDiameterFront = _.get(display, 'wheels.wheels_front_dimensions[1].diameter', null);
  const wheelsDiameterBack = _.get(display, 'wheels.wheels_back_dimensions[1].diameter', wheelsDiameterFront);

  let wheels_front = applySegment(wheelsDiameterFront, wheels_segments);
  let wheels_back = applySegment(wheelsDiameterBack, wheels_segments);

  const wheels_inches = _.get(display, 'wheels.wheels_inches[1]', null);

  if (wheels_inches) {
    wheels_front = wheels_inches;
    wheels_back = wheels_inches;
  }

  // power - essai dans vehicle_infos puis dans vehicle
  let power = _.get(display, 'vehicle_infos.kw', _.get(display, 'vehicle.kw[1]', null));
  try {
    if (power !== null) power = parseInt(power, 10);
  } catch (e) {
    power = null;
  }

  power = applySegment(power, power_segments);

  // age
  const now = moment();
  let age = null;
  let dateOfRelease = _.get(
    display,
    'vehicle.registrationDate[1]',
    _.get(
      display,
      'vehicle.dateOfRelease[1]',
      _.get(display, 'vehicle_infos.registrationDate[1]', _.get(display, 'vehicle_infos.dateOfRelease[1]', null)),
    ),
  );
  try {
    if (dateOfRelease !== null) {
      dateOfRelease = moment(dateOfRelease, 'YYYY-MM-DD');
      age = now.diff(dateOfRelease);
      age = moment.duration(age).asYears();
    }
  } catch (e) {
    age = null;
  }
  // console.log("age", age)

  age = applySegment(age, age_segments);

  const result = {
    wheels_front,
    wheels_back,
    power,
    age,
  };
  // console.log("segments", result)
  return result;
}
